import PropTypes from 'prop-types';

import FormButton from '../../../../ComponentLibrary/input-elements/oc-form-button';
import { connectLocation } from '../../../../location/LocationConnectors';
import { ActionsRow, Divider, Footnote, PdfIcon } from '../../styles';

const Footer = ({ codeLinkHref, results, onDownload, t }) => (
  <>
    <div style={{ fontSize: 13, paddingBottom: 24, paddingTop: 16 }}>
      {t('thermal_calculator.footnotes.consult_locations')}&nbsp;
      <a href={codeLinkHref} target="_blank" rel="noreferrer" style={{ color: '#D40F7D', textDecoration: 'underline' }}>
        {t('thermal_calculator.results_summary.naima')}
      </a>
    </div>

    <Divider />

    {results && (
      <ActionsRow>
        <FormButton onClick={onDownload}>
          <PdfIcon /> <span>{t('thermal_calculator.results_summary.download_results')}</span>
        </FormButton>
      </ActionsRow>
    )}

    <Footnote>{t('thermal_calculator.footnotes.first')}</Footnote>

    <Footnote style={{ marginTop: 10 }}>{t('thermal_calculator.footnotes.second')}</Footnote>

    <Footnote style={{ marginTop: 10 }}>
      <strong>{t('thermal_calculator.footnotes.please_contact')}</strong>
      <br />
      {t('thermal_calculator.footnotes.canada_inquiries')}:
      <br />
      {t('thermal_calculator.footnotes.salvatore_name')}
      <br />
      {t('thermal_calculator.footnotes.salvatore_phone')}
      <br />
      {t('thermal_calculator.footnotes.salvatore_email')}
    </Footnote>
  </>
);

Footer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  results: PropTypes.object,
  codeLinkHref: PropTypes.string,
  onDownload: PropTypes.func,
  t: PropTypes.func.isRequired,
};

Footer.defaultProps = {
  results: null,
  codeLinkHref: 'https://insulationinstitute.org/improve-your-home/insulation-requirements/',
  onDownload: () => {},
};

export default connectLocation(Footer);
